import React from 'react';

interface CouponContainerProps {
  active?: boolean;
  children?: React.ReactNode;
}

const CouponContainer = ({ active, children }: CouponContainerProps) => {
  return (
    <div className='coupon-info-box-styled'>
      <div className='selling-box'>
        <div className={`box ${active ? 'active' : ''}`} >
          <div style={{ width: '100%' }}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CouponContainer;